module.exports = __webpack_public_path__ + "img/icon-comment.2147dd47.svg";